import { render, staticRenderFns } from "./SubjectListWrapper.vue?vue&type=template&id=6d42390c&lang=html"
import script from "./SubjectListWrapper.vue?vue&type=script&lang=js"
export * from "./SubjectListWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../modules/rajalex/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports